<template>
  <div>
    <v-menu lazy :close-on-content-click="false" v-model="calendar" transition="scale-transition" offset-y full-width :nudge-right="80" max-width="290px" min-width="290px">
      <v-btn flat color="secondary" slot="activator" large>
        <v-icon left>mdi-calendar</v-icon>
        <span>
          {{dateDisplay}}
        </span>
      </v-btn>
      <v-date-picker scrollable v-model="modelDate">
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import format from 'date-fns/format'

export default {
  data() {
    return {
      calendar: false,
      dateNow: new Date(),
      modelDate: format(new Date(), 'yyyy-MM-dd')
    }
  },
  computed: {
    dateDisplay() {
      return format(this.dateNow, 'EEEE, MMMM dd')
    }
  },
  methods: {
    closeCalendar() {
      this.calendar = false
    }
  }
}
</script>

<style lang="scss">
// .date {
//   position: relative;
//   width: 70px;
//   color: #999;
//   margin: 0 auto;
//   cursor: pointer;
//   .day,
//   .month,
//   .year {
//     position: absolute;
//   }

//   .day {
//     font-size: 30px;
//     top: 15px;
//   }

//   .month {
//     top: 0;
//     left: 0;
//     font-size: 18px;
//   }

//   .year {
//     top: 19px;
//     right: 0;
//     font-size: 20px;
//     rotation: -90deg !important;
//     /* ** Hacks ** */
//     -webkit-transform: rotate(-90deg);
//     -moz-transform: rotate(-90deg);
//   }
// }
</style>
